import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/internal/Observable';

import { DownloadedItem } from '@app/models';

export interface DownloadedItemApi {
  items: DownloadedItem[];
  total_count: number;
}

@Injectable({
  providedIn: 'root'
})
export class DownloadedItemService {
  private _downloadItemRoute = '/api/downloaded-items/';

  private headerOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

  constructor(private httpClient: HttpClient) { }


  getUsersMaterialLibrary(_userId: string): Observable<DownloadedItem[]> {
    return this.httpClient.get<DownloadedItem[]>(this._downloadItemRoute + 'users-downloads/' + _userId);
  }


  checkIfUserOwns(_userId: string, _materialId: string): Observable<any> {
    return this.httpClient.get<any>(this._downloadItemRoute + 'checkIfUserOwns/' + _userId + '/' + _materialId);
  }


  getCustomDatasource(_searchParams, _sortField = 'downloadDate', _sortDirection = 'desc', _pageNumber: number = 0, _pageSize: number = 10): Observable<DownloadedItemApi> {
    _searchParams['selectAll'] = false;
    _searchParams.sortField = _sortField;
    _searchParams.sortOrder = (_sortDirection && _sortDirection !== '') ? _sortDirection : 'desc';
    _searchParams.pageNumber = _pageNumber;
    _searchParams.pageSize = _pageSize;

    return this.httpClient.post<DownloadedItemApi>(`${this._downloadItemRoute}dataSourceSearch`, JSON.stringify(_searchParams), this.headerOptions); 
  }


  create(_newDownloadItem: DownloadedItem): Observable<any> {
    // Only creates item if not one for the current user and material already. Returns success, existed, or failed;
    return this.httpClient.post<any>(this._downloadItemRoute, JSON.stringify(_newDownloadItem), this.headerOptions);
  }


  createMultiple(_downloads: any): Observable<any> {
    return this.httpClient.post<any>(this._downloadItemRoute + 'multiple', JSON.stringify(_downloads), this.headerOptions);
  }  


  delete(_downloadItem: DownloadedItem): Observable<any> {
    return this.httpClient.delete(this._downloadItemRoute + '/' + _downloadItem._id, this.headerOptions);
  }
}